import React from "react";
import { Col, Row } from "react-bootstrap";

export const getBalancedColumnCells = (columns, watch) => {
  const visibleColumns = columns.map((column) => {
    const columnHidden = column.hide ? column.hide({ watch }) : false;
    return columnHidden
      ? []
      : column.items.filter((item) => !(item.hide ? item.hide({ watch }) : false));
  });
  const [left = [], right = [], trailing = []] = visibleColumns;
  const pairedRows = Math.max(left.length, right.length);
  const cells = [];

  for (let row = 0; row < pairedRows; row += 1) {
    if (left[row]) cells.push({ item: left[row], column: 1, row: row + 1 });
    if (right[row]) cells.push({
      item: right[row],
      column: left[row] ? 2 : 1,
      row: row + 1,
    });
  }
  trailing.forEach((item, row) => cells.push({ item, column: 3, row: row + 1 }));

  return cells;
};

const containsFieldName = (item, name) => item?.name === name
  || item?.items?.some((child) => containsFieldName(child, name));

export const arrangeItemsByColumnNames = (items, columnNames) => columnNames.map((names) =>
  names.map((name) => items.find((item) => containsFieldName(item, name))).filter(Boolean));

export const FormRow = ({field, renderItem, rowIdentity, editTableProps, watch}) => {
  const hide = field.hideIf ? field.hideIf({editTableProps, rowIdentity, watch}) : false;

  if (field.balanceColumns) {
    const columns = field.balanceColumnNames
      ? arrangeItemsByColumnNames(field.items, field.balanceColumnNames).map((items) => ({ items }))
      : field.items;
    const cells = getBalancedColumnCells(columns, watch);

    return !hide && (
      <Row className={`uiRow balanced-columns${field.className ? ` ${field.className}` : ''}`} style={field.style}>
        {cells.map(({ item, column, row }, key) => (
          <Col
            key={key}
            className={`balanced-column-${column}${item.fitToContent ? ' col-md-auto' : ''}`}
            style={{ gridColumn: column, gridRow: row }}
          >
            {renderItem(item, rowIdentity, editTableProps)}
          </Col>
        ))}
      </Row>
    );
  }

  return (
    !hide && <Row className={`uiRow${field.className ? ` ${field.className}` : ''}`} style={field.style}>
      {field.items.map((item, key) => {
        const hidden = item?.hide ? item.hide({ watch }) : false;
        return (
          <Col key={key} style={{
            display: hidden ? 'none' : undefined,
            width: item.width ? item.width : undefined,
            maxWidth: item.width ? item.width : undefined,
          }} className={item.fitToContent ? "col-md-auto" : undefined}>
            {renderItem(item, rowIdentity, editTableProps)}
          </Col>
        )
      })}
    </Row>
  );
}